export default __webpack_public_path__ + "f95deaf435ac535d93071a12d66c730f.png";